module.exports = __webpack_public_path__ + "static/media/ic_add_canvas.eccbed86.svg";